import React, {useContext, useEffect, useState} from "react";
import "./index.scss";
import {v4 as uuidv4} from 'uuid';
import {Formik} from "formik";
import {FormRow} from "../../../../components/Form/FormRow";
import {FormItem} from "../../../../components/Form/FormItem";
import {useMediaQuery} from "@material-ui/core";
import active from '../../../../images/travel/active.svg'
import covid from '../../../../images/travel/covid.svg'
import franchise from '../../../../images/travel/zero-franschize.svg'
import age_range from '../../../../images/travel/age_range.svg'
import contract from '../../../../images/travel/contract.svg'
import file_download from '../../../../images/file_download.svg'
import TravelAdvantages from "../../../../components/TravelAdvantages";
import {Button} from "../../../../components/Button";
import {ITravelQuotationContext, TravelQuotationContext} from "../../../../contexts/TravelQuotationContext";
import {TravelQuotationCardContext} from "../../../../contexts/TravelQuotationCardContext";
import {ParametrizedFieldOld} from "../../../../components/ParametrizedFieldOld";
import moment from "moment";
import {strings} from "../../../../strings/strings";
import {ISelectItem} from "../../../../model/selectItem";
import * as log from "../../../../utils/log";
import {LogFunctionalModule} from "../../../../utils/log";
import {getSnippetByName} from "../../../../api/snippetApiClient";
import {ChatWidget} from "../../../../model/chatWidget";
import {WIDGET_DURATION, WidgetTooltip} from "../../../../App";
import {SimpleTooltip} from "../../../../components/SimpleTooltip";
import {ProcessingContext} from "../../../../contexts/ProcessingContext";
import {AutoSubmitting} from "../../../../components/AutoSubmitting";
import { TravelQuotation } from "../../../../model/quotation";
import {formatResponseForAutocomplete, formatSelectedOptionForAutocomplete} from "../../../../utils/formatAutocomplete";
import { TravelImportantInfoDescription } from "../../../../components/descriptions/travelImportantInfoDescription";
import { TravelStartDateDescription } from "../../../../components/descriptions/travelStartDateDescription";
import { TravelEndDateDescription } from "../../../../components/descriptions/travelEndDateDescription";

interface Props {
    onFormSubmit: (data: any) => void
}


export const travelAreaArray = [
    {
        label: strings.allWorld,
        value: 'ALL'
    },
    {
        label: strings.allWorldExceptUSACanadaIndonesiaThailandIndia,
        value: 'ALL_EXCEPT_THE_US_CANADA_INDONESIA_THAILAND_AND_INDIA'
    },
    {
        label: strings.allWorldExceptCanada,
        value: 'ALL_EXCEPT_THE_US_AND_CANADA'
    },
    {
        label: strings.europeCic,
        value: 'EUROPE_CIS_TURKEY_TUNISIA_EGYPT'
    },{
        label: strings.allWorldExceptUSIndonesiaThailandUkraine,
        value: "ALL_EXCEPT_THE_US_INDONESIA_THAILAND_AND_UKRAINE"
    }
]

const emptyPersonObject = {
    address: "",
    birthDate: null,
    documentNumber: "",
    givenName: null,
    id: "",
    middleName: null,
    mobileNumber:  null,
    residentCountry: "Україна",
    surname: null,
    travelPurpose: null
}

export const FastCalculationForm: React.FC<Props> = ({onFormSubmit}) => {
    const isMobile = useMediaQuery('(max-width: 1023px)');
    const {setProcessingOpen} = useContext(ProcessingContext);
    const {quotation} = useContext<ITravelQuotationContext>(TravelQuotationContext);
    const [tripsCount, setTripsCount] = useState(quotation.travelWebContract.tripsCount)
    const {startLoadingFromServer, validateFields, currentlyUpdatedFields} = useContext(TravelQuotationCardContext);

    useEffect(() => {
        startLoadingFromServer();
    }, []);

    function formatResponse(response: any) {
        return {
            quotationValue: response,
            value: response
        }
    }

    useEffect(() => {
        let event = 'travel_shop_buy';
        console.log('Google Analytics Event = ' + event);
        // @ts-ignore
        window.dataLayer.push({'event': event});
    }, []);

    React.useEffect(() => {
        let timout: NodeJS.Timeout
        getSnippetByName(ChatWidget.TEMPLATE_HINT_HELLO).then(res => {
            timout = setTimeout(() => {
                WidgetTooltip?.open(res.text, WIDGET_DURATION)
            }, 500)
        })

        return () => {
            clearTimeout(timout)
            WidgetTooltip?.close()
        }
    }, [])

    const saveTempValues = (quotation:TravelQuotation) => {
        if( quotation ){
            localStorage.setItem("TRAVEL_quotation", JSON.stringify(quotation))
        }
    }

    return (
            <Formik initialValues={quotation}
                    onSubmit={(data) => {
                        data.travelWebContract.tripsCount = tripsCount;

                        validateFields(data).then(res => {
                            if (res) {
                                onFormSubmit(data)
                            } else {
                                setProcessingOpen(false)
                            }
                        })
                    }}
                    validateOnChange={false}
                    validateOnBlur={true}
            >
                {formProps => {
                    saveTempValues(formProps.values)
                    return (
                        <AutoSubmitting updatedFieldsArray={currentlyUpdatedFields}>
                        <form className={"start-form-step"}>

                            <h3 className={'mb-50'}>{strings.calculateDetails}</h3>

                            <FormRow type={'travel'} className={'start-form-step_row'}>
                                <FormItem colspan={isMobile ? 1 : 2}>
                                    <ParametrizedFieldOld contextName={'travelArea'} defaultLabel={strings.coveredZone}
                                                       quotationName={'travelWebContract.'}
                                                       context={TravelQuotationCardContext}
                                                       formatResponse={formatResponse}/>
                                </FormItem>
                                <FormItem colspan={1}>
                                    <ParametrizedFieldOld contextName={'touristCount'} defaultLabel={strings.touristCount}
                                                       quotationName={'travelWebContract.'}
                                                       context={TravelQuotationCardContext}
                                                       numericSelectOptions={() => [1, 2, 3, 4, 5]}
                                                       formatResponse={formatResponse}
                                                       onChangeListener={(val) => {
                                                            const persons = formProps.values.travelWebContract.persons.slice(0, val)
                                                            if( val > persons.length ){
                                                                for( let i = persons.length; i < val; i++ ){
                                                                    persons.push({
                                                                        ...emptyPersonObject,
                                                                        id: uuidv4(),
                                                                        travelPurpose: persons[0].travelPurpose
                                                                    })
                                                                }
                                                            }
                                                            formProps.setFieldValue('travelWebContract.persons', persons)
                                                       }}/>
                                </FormItem>
                            </FormRow>

                            <FormRow type={'travel'} className={'start-form-step_row'} columns={1}>
                                <FormItem>
                                    <ParametrizedFieldOld
                                        contextName={'preferCountry'}
                                        quotationName={'travelWebContract.'}
                                        context={TravelQuotationCardContext}
                                        formatResponse={formatResponseForAutocomplete}
                                        formatSelected={
                                            formatSelectedOptionForAutocomplete
                                        }
                                        defaultLabel={strings.travel.forms.preferCountry}
                                        fieldInfoText={strings.travel.forms.importantInfo}
                                        fieldInfoTextLeaveTouchDelay={0}
                                        fieldInfoTextPosition={"left"}
                                        messageInfoObj={<TravelImportantInfoDescription />}
                                    />
                                </FormItem>
                            </FormRow>


                            <FormRow type={'travel'} className={'start-form-step_row'} columns={2}>
                                <ParametrizedFieldOld 
                                    contextName={'startDate'} 
                                    quotationName={'travelWebContract.'}
                                    context={TravelQuotationCardContext}
                                    formatResponse={(option: string) => {
                                        const date = moment(option, 'DD.MM.YYYY').toDate();
                                        return {
                                            quotationValue: moment(date).format('YYYY-MM-DD'),
                                            value: moment(date).format('DD.MM.YYYY')
                                        }
                                    }}
                                    onChangeListener={(selectedNextToDate: string) => {
                                        formProps.setFieldValue("travelWebContract.startDate", moment(selectedNextToDate).format('YYYY-MM-DD'));
                                    }} 
                                    minDate={new Date()}
                                    defaultLabel={strings.travel.forms.startDate}
                                    messageInfoObj={<TravelStartDateDescription />}
                                    fieldInfoTextPosition={"info"}
                                />
                                <ParametrizedFieldOld 
                                    contextName={'endDate'} 
                                    quotationName={'travelWebContract.'}
                                    context={TravelQuotationCardContext}
                                    formatResponse={(option: string) => {
                                        const date = moment(option, 'DD.MM.YYYY').toDate();
                                        return {
                                            quotationValue: moment(date).format('YYYY-MM-DD'),
                                            value: moment(date).format('DD.MM.YYYY')
                                        }
                                    }} 
                                    onChangeListener={(selectedNextToDate: string) => {
                                        formProps.setFieldValue("travelWebContract.endDate", moment(selectedNextToDate).format('YYYY-MM-DD'));
                                    }} 
                                    minDate={new Date(formProps.values.travelWebContract.startDate)}
                                    defaultLabel={strings.travel.forms.endDate}
                                    messageInfoObj={<TravelEndDateDescription />}
                                    fieldInfoTextPosition={"info"}
                                />
                            </FormRow>


                            <FormRow type={'travel'} className={'start-form-step_row'}>
                                <FormItem colspan={isMobile ? 1 : 3}>
                                    <ParametrizedFieldOld 
                                        contextName={'travelPurpose'}
                                        placeholder={strings.travelPurpose}
                                        contextPath="mainContract"
                                        quotationName={'travelWebContract.'}
                                        context={TravelQuotationCardContext}
                                        formatResponse={formatResponse}
                                        formatOptions={(options: ISelectItem[]) => {
                                            options = options.map(option => {
                                                if (option.value === 'TOURISM') {
                                                    return option
                                                } else {
                                                    const optionSplice = option.label.split('+')
                                                    option.label = optionSplice[0] + ' + ' + options[0].label
                                                    return option
                                                }})
                                            return options;
                                        }}
                                        onChangeListener={val => {
                                            const persons = formProps.values.travelWebContract.persons.map(item => {
                                                return {
                                                    ...item,
                                                    travelPurpose: val
                                                }
                                            })
                                            formProps.setFieldValue('travelWebContract.persons', persons)
                                            formProps.setFieldValue('travelWebContract.travelPurpose', val)
                                        }}
                                        defaultLabel={strings.travelPurpose}
                                    />
                                </FormItem>
                            </FormRow>

                            <FormRow type={'travel'} className={'start-form-step_submit-button'} columns={2}>
                                <Button onClickListener={() => {
                                    const date = new Date();
                                    log.sendLog(date, LogFunctionalModule.STORE_TRAVEL, 'INFO', "CALCULATION_FORM_NEXT_HANDLER", [{
                                        quotation: quotation,
                                        formProps: formProps
                                    }], '')
                                    formProps.setSubmitting(true)
                                }} label={strings.toCalculate}/>
                            </FormRow>


                            <h3>{strings.ourAdv}</h3>
                            <FormRow type={'travel'} className={'start-form-step_row'} columns={3} contentNumber={5}>
                                <TravelAdvantages icon={franchise} text={strings.franchiseAdv}/>
                                <TravelAdvantages icon={active} text={strings.activeAdv}/>
                                <TravelAdvantages icon={age_range} text={strings.ageRange}/>
                            </FormRow>

                            <h3>{strings.importantInfo}</h3>
                            <div className={'info-block'}>
                                <img src={file_download} alt="icon"/>
                                <div className={'info-block__text'}>
                                    <span onClick={() => {window.open(`${process.env.PUBLIC_URL}/resources/product_conditions_travel.pdf`);}}
                                          className={'info-block__text--header'}>
                                        {strings.policyTermsFile}
                                    </span>
                                    <span className={'info-block__text--label'}>{".pdf"}</span>
                                </div>
                            </div>
                        </form>
                        </AutoSubmitting>
                    )

                }}
            </Formik>
    )
};
